import styles from './FilterForm.module.css'
import { BedroomsFilterContainer } from './containers/BedroomsFilterContainer'
import { BedsFilterContainer } from './containers/BedsFilterContainer'
import { PetsFilterContainer } from './containers/PetsFilterContainer'
import { useState } from 'react'

interface FilterFormProps {
    filters: any
    onFiltersChange?: (event: any) => void
}

export const FilterForm = (props: FilterFormProps): JSX.Element => {
    const {
        filters,
        onFiltersChange,
    } = props
 
    const [openSelectors, setOpenSelectors] = useState({
        bedrooms: false,
        beds: false,
        pets: false,
    })

    const handleFilterSelectorOpen = (event: any) => {
        setOpenSelectors({
            bedrooms: false,
            beds: false,
            pets: false,
            [event]: true
        })
    }

    const handleFilterSelectorClose = (event: any) => {
        setOpenSelectors({
            bedrooms: false,
            beds: false,
            pets: false,
        })
    }

    const handleSelectedItemsChanged = (event: any) => {
        onFiltersChange?.({
            ...filters,
            [event.propertyName]: event.selectedItems
        })
    }

    return (
        <div className={styles.FilterForm}>
            <div className={styles.FilterForm__Content}>
                <div className={styles.FilterForm__CenterContainer}>
                    <div className={styles.Dialog__FilterListContainer}>
                        <BedroomsFilterContainer
                            open={openSelectors[`bedrooms`]}
                            propertyName={`bedrooms`}
                            initialSelectedItems={filters[`bedrooms`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}

                        />
                        <BedsFilterContainer
                            open={openSelectors[`beds`]}
                            propertyName={`beds`}
                            initialSelectedItems={filters[`beds`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}
                        />
                        <PetsFilterContainer
                            open={openSelectors[`pets`]}
                            propertyName={`pets`}
                            initialSelectedItems={filters[`pets`]}
                            onOpen={handleFilterSelectorOpen}
                            onClose={handleFilterSelectorClose}
                            onSelectedItemsChanged={handleSelectedItemsChanged}
                        />
                    </div>
                </div>
            </div>   
        </div>         
    )
}